import { Component } from 'react';
import numeral from 'numeral';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ArrowComponent from '../../shared_components/buttons/ArrowComponent';

class OverviewTableRowsComponent extends Component {
  constructor(props) {
    super(props);

    this.getFormattedInterestForLabel = this.getFormattedInterestForLabel.bind(this);
  }

  getFormattedInterestForLabel(label, index, interestType) {
    let labelInterest = numeral(label.interests[index][interestType] / 100).format('%0.00');

    if (label.interests[index][interestType] === 0) {
      labelInterest = '-';
    }

    return labelInterest;
  }

  render() {
    const {
      sortedOverviewTableColumn,
      firstOverviewTableColumnFixedRateTerm,
      firstColumnIndex,
      secondOverviewTableColumnFixedRateTerm,
      secondColumnIndex,
      labelInterestsLoadingClassName,
      sortedClassName,
      label,
    } = this.props;

    return (
      <tr key={label.id}>
        <td>
          {<img src={label.logo} alt="logo" />}
        </td>
        <td>
          {label.product}
        </td>

        {/* 10 year frt */}
        <td
          className={sortedOverviewTableColumn === `initialInterest-${firstOverviewTableColumnFixedRateTerm}` ?
            sortedClassName : ''}
        >
          <span className={'mobile-only'}>Aanvangsrente {firstOverviewTableColumnFixedRateTerm} jaar: </span>
          {this.getFormattedInterestForLabel(label, firstColumnIndex, 'initialInterest')}
        </td>

        <td
          className={sortedOverviewTableColumn === `averageInterest-${firstOverviewTableColumnFixedRateTerm}` ?
            sortedClassName : ''}
        >
          <span className={'mobile-only'}>Looptijdrente {firstOverviewTableColumnFixedRateTerm} jaar: </span>
          {this.getFormattedInterestForLabel(label, firstColumnIndex, 'averageInterest')}
        </td>

        {/* 20 year frt */}
        <td
          className={sortedOverviewTableColumn === `initialInterest-${secondOverviewTableColumnFixedRateTerm}` ?
            sortedClassName : ''}
        >
          <span className={'mobile-only'}>Aanvangsrente {secondOverviewTableColumnFixedRateTerm} jaar: </span>
          {this.getFormattedInterestForLabel(label, secondColumnIndex, 'initialInterest')}
        </td>
        <td
          className={sortedOverviewTableColumn === `averageInterest-${secondOverviewTableColumnFixedRateTerm}` ?
            sortedClassName : ''}
        >
          <span className={'mobile-only'}>Looptijdrente {secondOverviewTableColumnFixedRateTerm} jaar: </span>
          {this.getFormattedInterestForLabel(label, secondColumnIndex, 'averageInterest')}
        </td>

        {/* Looptijdrente */}
        <td className={sortedOverviewTableColumn === 'averageInterestAvailable' ? 'bold icon-td' : 'icon-td'}>
          <span className={'mobile-only'}>Looptijdrente mogelijk: </span>
          {(label.hasAutoRiskClassReduction &&
            <img src="/images/looptijdrente-icoon.png" alt="Ja" className="icon" />) || 'Nee'}
        </td>
        <td colSpan={2} className="semi-bold">
          <Link to={`bereken/${label.id}`}>Bereken uw maandlasten<ArrowComponent /></Link>
        </td>
        <td className={labelInterestsLoadingClassName || ''} />
      </tr>
    );
  }
}

OverviewTableRowsComponent.propTypes = {
  sortedOverviewTableColumn: PropTypes.string,
  firstOverviewTableColumnFixedRateTerm: PropTypes.number,
  sortedClassName: PropTypes.string,
  secondOverviewTableColumnFixedRateTerm: PropTypes.number,
  label: PropTypes.shape({}),
  firstColumnIndex: PropTypes.number,
  secondColumnIndex: PropTypes.number,
  labelInterestsLoadingClassName: PropTypes.string,
};

OverviewTableRowsComponent.defaultProps = {
  sortedOverviewTableColumn: '',
  firstOverviewTableColumnFixedRateTerm: 0,
  sortedClassName: '',
  secondOverviewTableColumnFixedRateTerm: 0,
  label: {},
  firstColumnIndex: 0,
  secondColumnIndex: 0,
  labelInterestsLoadingClassName: '',
};

export default OverviewTableRowsComponent;
